import * as protobuf from 'protobufjs';
const localViewJson = require('@/components/XMonitor/proto/local_view.json');
const localViewRoot = protobuf.Root.fromJSON(localViewJson);
const localViewType = localViewRoot.lookupType(
  'jdx.rover.hermes.dto.LocalViewDTO'
);
const driveDataDTO = require('@/proto/drive_data_dto.json');
const driveDataDTORoot = protobuf.Root.fromJSON(driveDataDTO);
const driveDataDTOType = driveDataDTORoot.lookupType(
  'jdx.rover.to.proto.DriveDataDTO'
);
export { localViewType, driveDataDTOType };
